const listOfRestaurants = {
    "1":{
        "name": "Benny Tudinos",
        "type": "Pizzeria",
        "price": "medium",
        "rating": 4.4
    },
    "2":{
        "name": "La Isla",
        "type": "Cuban",
        "price": "medium",
        "rating": 4.5
    },
    "3":{
        "name": "Gogi Grill",
        "type": "Korean",
        "price": "medium",
        "rating": 4.3
    },
    "4":{
        "name": "Elysian Cafe",
        "type": "French",
        "price": "medium",
        "rating": 4.5
    },
    "5":{
        "name": "Sauced",
        "type": "Sandwiches",
        "price": "low",
        "rating": 4.8
    },
    "6":{
        "name": "Karma Kafe",
        "type": "Indian",
        "price": "medium",
        "rating": 4.4
    },
    "7":{
        "name": "Vito's Deli",
        "type": "Italian",
        "price": "medium",
        "rating": 4.8
    },
    "8":{
        "name": "Ali Baba",
        "type": "Middle Eastern",
        "price": "medium",
        "rating": 4.5
    },
    "9":{
        "name": "Makai Poke",
        "type": "Poke",
        "price": "medium",
        "rating": 4.4
    },
    "10":{
        "name": "Amanda's Restaurant",
        "type": "Breakfast/Brunch",
        "price": "high",
        "rating": 4.6
    },
    "11":{
        "name": "Frankie and Avas",
        "type": "Italian",
        "price": "medium",
        "rating": 4.1
    },
    "12":{
        "name": "Fiore's Deli",
        "type": "Deli",
        "price": "medium",
        "rating": 4.8
    },
    "13":{
        "name": "Precious",
        "type": "Chinese",
        "price": "medium",
        "rating": 4.1
    },
    "14":{
        "name": "Robongi",
        "type": "Japanese",
        "price": "medium",
        "rating": 4.1
    },
    "15":{
        "name": "Empanadas Cafe",
        "type": "Cafe",
        "price": "low",
        "rating": 4.3
    },
    "16":{
        "name": "Cluck U Chicken",
        "type": "Chicken",
        "price": "low",
        "rating": 3.9
    },
    "17":{
        "name": "Augustino's",
        "type": "Italian",
        "price": "high",
        "rating": 4.4
    },
    "18":{
        "name": "Midtown Philly Steaks",
        "type": "Sandwiches",
        "price": "low",
        "rating": 4.3
    },
    "19":{
        "name": "Court Street",
        "type": "Bar",
        "price": "medium",
        "rating": 4.6
    },
    "20":{
        "name": "Pho Nomenon",
        "type": "Vietnamese",
        "price": "low",
        "rating": 3.9
    }
};

export {listOfRestaurants};